const pt = {
  // Navigation
  "nav.home": "Início",
  "nav.about": "Sobre nós",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Atualizações",
  "nav.fwb": "FWB",
  "nav.tokensale": "Venda de Tokens",
  
  // Common sections
  "common.learnMore": "Saiba mais",
  "common.buyNow": "Comprar agora",
  "common.contactUs": "Contate-nos",
  "common.loading": "Carregando",
  
  // Home page
  "home.hero.title": "A evolução dos pagamentos digitais",
  "home.hero.subtitle": "eDOP Token: O token utilitário para o ecossistema financeiro da República Dominicana",
  "home.hero.cta": "Participar da pré-venda",
  "home.title": "eDOP: Revolução Digital",
  
  // About
  "about.title": "Sobre o eDOP Token",
  "about.description": "eDOP Token é um token digital projetado para revolucionar pagamentos na República Dominicana",
  
  // Página Sobre Nós
  "about.page.title": "Sobre Nós",
  
  // Bolhas da página Sobre Nós
  "bubbles.about.edop.title": "Sobre o eDOP",
  "bubbles.about.edop.content": "eDOP é uma alternativa digital eficiente e acessível no ecossistema cripto, projetada para abordar problemas de acesso financeiro, especialmente em mercados emergentes. Integra facilidade de uso com segurança, buscando adoção global.",
  
  "bubbles.about.mission.title": "Nossa Missão",
  "bubbles.about.mission.content": "Democratizar o acesso a serviços financeiros digitais, oferecendo ferramentas acessíveis que permitam às pessoas assumir o controle de suas finanças sem intermediários caros.",
  
  "bubbles.about.transparency.title": "Transparência",
  "bubbles.about.transparency.content": "Todas as operações são registradas de forma imutável na blockchain, garantindo transparência absoluta. Além disso, nos comprometemos a publicar os resultados das auditorias de segurança para gerar confiança.",
  
  "bubbles.about.innovation.title": "Inovação",
  "bubbles.about.innovation.content": "Inovamos ao oferecer uma solução cripto centrada no usuário para inclusão financeira, com um ecossistema que inclui pagamentos de baixo custo, incentivos e desenvolvimentos futuros como um DEX próprio e um aplicativo móvel.",
  
  "bubbles.about.community.title": "Comunidade",
  "bubbles.about.community.content": "Fomentamos uma comunidade comprometida através de um sistema de incentivos que recompensa a participação, o staking e o uso ativo do ecossistema, buscando uma distribuição equilibrada e a expansão de nossa base de usuários.",
  
  "bubbles.about.team.title": "Nossa Equipe",
  "bubbles.about.team.content": "Contamos com uma equipe multidisciplinar com ampla experiência em finanças digitais, desenvolvimento blockchain e mercados emergentes, apoiada por consultores estratégicos em áreas-chave como regulação e economia.",
  
  "bubbles.about.technology.title": "Nossa Tecnologia",
  "bubbles.about.technology.content": "eDOP é um token BEP-20 que opera na BNB Smart Chain (BSC), escolhida por seu equilíbrio ideal entre velocidade, segurança e custos acessíveis, utilizando smart contracts desenvolvidos sob as melhores práticas.",
  
  "bubbles.about.speed.title": "Velocidade",
  "bubbles.about.speed.content": "Graças à BNB Smart Chain, as transações com eDOP Token são confirmadas rapidamente, tipicamente entre 3 e 15 segundos, oferecendo uma eficiência superior aos sistemas tradicionais e outras blockchains.",
  
  "bubbles.about.lowcost.title": "Baixo Custo",
  "bubbles.about.lowcost.content": "eDOP oferece taxas drasticamente reduzidas, situando-se entre 0% e 1% por transação, em comparação com 5% a 10% das empresas tradicionais de remessas. Isso é alcançado através do uso da eficiente rede BNB Smart Chain, contratos inteligentes otimizados e a eliminação de intermediários, permitindo transações acessíveis, mesmo para micropagamentos.",
  
  "bubbles.about.security.title": "Segurança e Contato",
  "bubbles.about.security.content": "A segurança é prioritária, implementando contratos auditados por empresas reconhecidas, ferramentas comprovadas (OpenZeppelin), sistemas multi-assinatura e monitoramento constante. Para consultas, contate-nos em info@edoptoken.com, admin@edoptoken.com ou através de nossas redes sociais oficiais publicadas em nosso site.",
  
  // Tokenomics
  "tokenomics.title": "Distribuição de Tokens",
  "tokenomics.supply": "Fornecimento total",
  
  // Página de Tokenomics
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "Distribuição e Economia do Token eDOP",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Conteúdo: O token eDOP tem uma oferta total fixa de 1 bilhão de unidades (1.000.000.000 eDOP). Seu design econômico inclui uma distribuição estratégica para incentivar a participação antecipada, recompensar usuários de longo prazo através de staking, garantir liquidez de mercado e financiar o desenvolvimento contínuo e adoção do ecossistema.",
  
  "tokenomics.distribution.title": "Distribuição do Token",
  "tokenomics.distribution.content": "A oferta total de 1 bilhão de eDOP é alocada da seguinte forma:",
  "tokenomics.distribution.items": [
    "40% Pré-venda pública: Para os primeiros adotantes.",
    "30% Recompensas de Staking: Distribuídas ao longo de 2 anos para recompensar os detentores.",
    "10% Liquidez: Bloqueada por um mínimo de 10 anos ou perpetuamente para estabilidade.",
    "10% Marketing e adoção: Para crescimento e divulgação.",
    "5% Desenvolvimento: Com liberação gradual para a equipe (vesting).",
    "5% Inventário de Cadeia: Para operações técnicas do ecossistema."
  ],
  
  "tokenomics.purpose.title": "eDOP: Um Token com Propósito",
  "tokenomics.purpose.content": "Com uma oferta total limitada a 1 bilhão de unidades, o token eDOP é projetado para ser útil e sustentável. Sua distribuição estratégica garante fundos para recompensas de staking (30%), liquidez de longo prazo (10%) e crescimento. Principalmente, você pode usar eDOP como um meio de pagamento eficiente e de baixo custo, ou bloqueá-lo (staking) para obter recompensas e benefícios adicionais dentro do nosso ecossistema financeiro digital.",
  
  "tokenomics.utility.title": "Utilidade do Token",
  "tokenomics.utility.items": [
    "Governança: Os detentores de eDOP podem votar em propostas-chave que afetam o desenvolvimento e direção do projeto.",
    "Staking: Obtenha recompensas significativas fazendo staking de seus tokens, com taxas anuais competitivas.",
    "Taxas Reduzidas: Usuários que possuem eDOP desfrutam de taxas reduzidas em todas as transações dentro da plataforma.",
    "Acesso a Recursos Exclusivos: Desbloqueie funcionalidades avançadas e ferramentas dentro da nossa plataforma.",
    "Meio de Pagamento: Utilize eDOP para transações rápidas e econômicas dentro do nosso ecossistema."
  ],
  
  // Token sale
  "tokensale.title": "Venda de Tokens",
  "tokensale.subtitle": "Participe da nossa pré-venda",
  "tokensale.price": "Preço atual",
  "tokensale.connect": "Conectar carteira",
  
  // Footer
  "footer.rights": "Todos os direitos reservados",
  "footer.terms": "Termos e condições",
  "footer.privacy": "Política de privacidade",
  "footer.fwb": "Amigos com Benefícios",
  
  // Wallet
  "wallet.connect": "Conectar Carteira",
  "wallet.error.networkSwitch": "Erro ao mudar de rede",
  
  // News
  "news.label": "NOTÍCIAS",
  
  // Bolhas da página inicial
  "bubbles.home.revolution.title": "eDOP: Revolução de Mercado",
  "bubbles.home.revolution.content": "O token eDOP visa fornecer uma alternativa digital eficiente e acessível no ecossistema de criptomoedas, com foco inicial em mercados emergentes e uma visão de adoção global.",
  
  "bubbles.home.ecosystem.title": "O Ecossistema eDOP",
  "bubbles.home.ecosystem.content": "Não perca a oportunidade de fazer parte da próxima geração de soluções blockchain no mundo cripto.",
  
  // Botões e textos adicionais
  "cta.whitepaper": "Livro Branco",
  
  // Página Política de Privacidade
  "privacy.page.title": "Política de Privacidade",
  
  // Bolhas da Política de Privacidade
  "bubbles.privacy.commitment.title": "Compromisso com Sua Privacidade",
  "bubbles.privacy.commitment.content": "Na eDOP Token, estamos comprometidos com a total transparência e proteção de seus dados. Como um projeto focado na democratização do acesso a serviços financeiros digitais, entendemos a importância da confiança.",
  
  "bubbles.privacy.nocollection.title": "Não Coletamos Informações",
  "bubbles.privacy.nocollection.content": "Para cumprir nossa missão de inclusão financeira, nunca solicitamos ou pedimos dados de identificação. Evite ser vítima de phishing e nunca revele suas chaves privadas ou frases semente - eDOP Token nunca solicitará isso, lembre-se.",
  
  "bubbles.privacy.usage.title": "Como Usamos Suas Informações",
  "bubbles.privacy.usage.content": "Não coletamos dados pessoais ou qualquer informação. Usamos apenas seu endereço de carteira para operar, dados técnicos para manter a segurança da plataforma e, opcionalmente, alguns detalhes que melhoram sua experiência. Tudo sob boas práticas e sem compartilhar informações com terceiros.",
  
  "bubbles.privacy.security.title": "Segurança e Proteção",
  "bubbles.privacy.security.content": "Aplicamos as mesmas medidas de segurança que protegem nossos contratos inteligentes: protocolos OpenZeppelin, multi-assinatura em operações-chave, limites para reduzir riscos e monitoramento constante. Tudo está alinhado com nossas auditorias, garantindo a segurança de seus dados e ativos digitais.",
  
  // Página Amigos com Benefícios (FWB)
  "fwb.page.title": "Amigos com Benefícios (FWB)",
  
  // Bolhas da página FWB
  "bubbles.fwb.community.title": "Comunidade eDOP (FWB)",
  "bubbles.fwb.community.content": "Na eDOP, acreditamos em uma comunidade global que busca democratizar o acesso financeiro. Nosso ecossistema é projetado para que os usuários assumam o controle e colaborem para uma economia digital mais equitativa, especialmente em mercados emergentes.",
  
  "bubbles.fwb.join.title": "Como Se Juntar e Participar",
  "bubbles.fwb.join.content": "Torne-se parte ativa da eDOP usando o token para pagamentos, participando do nosso programa de staking para apoiar a rede e se preparando para contribuir com a futura governança do ecossistema. Sua participação é fundamental para nosso crescimento.",
  "bubbles.fwb.join.date": "Data: 04 de abril de 2025",
  
  "bubbles.fwb.benefits.title": "Benefícios da Comunidade eDOP",
  "bubbles.fwb.benefits.content": "Ao participar da eDOP, você pode ganhar recompensas periódicas através do staking (provenientes de 30% do suprimento total alocado). Além disso, a posse ativa pode lhe dar acesso a benefícios como descontos em taxas ou prioridade em novos recursos do ecossistema.",
  
  "bubbles.fwb.connect.title": "Conecte-se com a Comunidade",
  "bubbles.fwb.connect.content": "Mantenha-se informado e conectado com o projeto eDOP. Encontre links para nossos canais oficiais da comunidade, documentação técnica e métodos de contato diretamente em nosso site oficial.",
  
  // Página Termos e Condições
  "terms.page.title": "Termos e Condições",
  
  // Bolhas da página Termos
  "bubbles.terms.risk.title": "Avisos de Risco:",
  "bubbles.terms.risk.content": "O investimento em eDOP Token envolve riscos significativos, incluindo alta volatilidade e a possível perda total ou parcial de capital. O valor do token depende do mercado, não há garantia de rentabilidade e os ativos digitais não possuem seguro de depósito. Considere cuidadosamente sua tolerância ao risco antes de investir.",
  
  "bubbles.terms.liability.title": "Limitação de Responsabilidade",
  "bubbles.terms.liability.content": "O desempenho do eDOP Token está sujeito a riscos de mercado além do controle do emissor (Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL). Não nos responsabilizamos por perdas resultantes da volatilidade, flutuações de liquidez ou riscos inerentes ao investimento em ativos digitais.",
  
  "bubbles.terms.issuer.title": "Emissor e Conformidade Legal",
  "bubbles.terms.issuer.content": "eDOP Token é emitido por Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL, uma entidade legalmente constituída. Buscamos operar em conformidade com as regulamentações aplicáveis e contamos com assessoria jurídica em matéria de ativos digitais e direito financeiro.",
  
  "bubbles.terms.contact.title": "Contato",
  "bubbles.terms.contact.content": "Para consultas relacionadas a estes termos, ao projeto eDOP Token ou para mais informações, você pode entrar em contato com nosso Email: ou consultar recursos adicionais em nosso Site.",
  
  // Página de Atualizações de Desenvolvimento
  "devupdates.page.title": "Atualizações de Desenvolvimento",
  
  // Bolhas da página de Atualizações
  "bubbles.devupdates.intro.title": "Atualizações de Desenvolvimento",
  "bubbles.devupdates.intro.content": "De acordo com o plano técnico descrito no whitepaper, o desenvolvimento do eDOP se concentra na criação de componentes-chave como uma plataforma de pagamento de baixo custo, uma futura exchange descentralizada proprietária (DEX) e um aplicativo móvel. Todo o ecossistema é projetado para operar na BNB Smart Chain, buscando um equilíbrio entre eficiência, segurança e acessibilidade.",
  
  "bubbles.devupdates.latest.title": "Últimas Atualizações",
  "bubbles.devupdates.latest.content": "Com base no plano original do whitepaper e preparando-nos para nossa Fase 1 (estimada para o final do Q2 2025), nosso foco atual inclui preparativos para o lançamento do token, ativação da plataforma de pagamento e garantir as listagens iniciais em exchanges. Para progresso real e anúncios confirmados, sempre verifique nossos canais oficiais.",
  "bubbles.devupdates.latest.date": "Data: 28 de abril de 2025",
  
  "bubbles.devupdates.events.title": "Próximos Eventos Comunitários",
  "bubbles.devupdates.events.content": "Nossa comunidade estabelecerá um plano para interação ativa com a comunidade, mencionando estratégias como webinars educacionais regulares e presença em eventos-chave do setor. Embora datas para as próximas sessões de AMA ou outros eventos específicos não sejam especificadas no documento, nosso compromisso é manter uma comunicação fluida e educativa.",
  "bubbles.devupdates.events.date": "Data: 28 de abril de 2025",
  
  "bubbles.devupdates.technical.title": "Atualização Técnica: Auditoria de Smart Contract",
  "bubbles.devupdates.technical.content": "De acordo com nossa abordagem de segurança descrita no whitepaper, existe um compromisso de que os smart contracts do eDOP Token sejam auditados por empresas externas reconhecidas (exemplos como CertiK ou Hacken são mencionados) antes do lançamento. Estes relatórios de auditoria estão planejados para serem publicados em nosso site para total transparência com a comunidade.",
  "bubbles.devupdates.technical.date": "Data: 28 de abril de 2025",
  
  "bubbles.devupdates.partnership.title": "Anúncio de Parceria Estratégica",
  "bubbles.devupdates.partnership.content": "Nosso whitepaper estabelece a estratégia e a importância de formar alianças estratégicas para o crescimento e utilidade do eDOP Token, mencionando planos para colaborar com comerciantes, especialmente em mercados emergentes. No entanto, o documento fundador não contém anúncios específicos de parcerias já assinadas; ele descreve a intenção e abordagem para buscá-las como parte do roadmap.",
  "bubbles.devupdates.partnership.date": "Data: 28 de abril de 2025",
  
  "bubbles.devupdates.previous.title": "Atualizações Anteriores",
  "bubbles.devupdates.previous.content1": "O whitepaper serve como plano mestre inicial e apresentação do projeto eDOP Token. Por sua natureza, atualizações anteriores ou marcos já completados desde sua publicação aparecerão nos canais oficiais para informação.",
  "bubbles.devupdates.previous.content2": "Para acessar um arquivo de notícias, avanços e anúncios anteriores, dirija-se às seções de notícias/blog ou canais históricos nas redes sociais oficiais do eDOP. Volte aqui para ver todas as nossas atualizações anteriores!",

  // Página de Vesting
  "vesting.page.title": "Plataforma de Vesting eDOP",
  
  // Página de Vesting - Bolhas
  "bubbles.vesting.platform.title": "Plataforma de Vesting eDOP",
  "bubbles.vesting.platform.content": "Os tokens destinados à equipe de desenvolvimento (5% do total) não são entregues todos de uma vez. Primeiro, eles são completamente bloqueados por 120 dias. Depois, a equipe recebe uma pequena porção a cada mês (2% linear de sua alocação). Este processo é chamado de vesting e garante que a equipe permaneça comprometida com o projeto eDOP Token a longo prazo.",
  
  "bubbles.vesting.emission.title": "Emissão Gradual de Tokens",
  "bubbles.vesting.emission.content": "eDOP controla a liberação lenta de tokens com o vesting para a equipe e a distribuição gradual de recompensas de staking (30% em 2 anos). Esta emissão controlada busca evitar quedas bruscas de preço e alinhar a circulação de tokens com o crescimento do projeto.",

  // Componente VestingBox3
  "vestingBox3.calendar": "Calendário de Vesting",
  "vestingBox3.start": "Início",
  "vestingBox3.end": "Fim",
  "vestingBox3.cliffPeriod": "Período de Cliff",
  "vestingBox3.loading": "Carregando...",
  "vestingBox3.days": "dias",
  "vestingBox3.progress": "Progresso",
  "vestingBox3.viewDetailedCalendar": "Ver Calendário Detalhado",
  "vestingBox3.vestingStart": "Início do Vesting",
  "vestingBox3.cliffEnd": "Fim do Período de Cliff",
  "vestingBox3.vestingEnd": "Fim do Vesting",
  "vestingBox3.weeklyReleases": "Liberações Semanais",
  "vestingBox3.releaseDescription": "Após o período de cliff de 90 dias, seus tokens são liberados semanalmente a 1% durante aproximadamente 2 anos.",
  "vestingBox3.close": "Fechar",

  // Componente VestingBox4
  "vestingBox4.claimedTokens": "Tokens Reivindicados",
  "vestingBox4.loading": "Carregando...",
  "vestingBox4.availableToClaim": "Disponíveis para Reivindicar",
  "vestingBox4.processing": "Processando...",
  "vestingBox4.claimTokens": "Reivindicar Tokens",
  "vestingBox4.successTransaction": "Transação Bem-Sucedida!",
  "vestingBox4.claimSuccess": "Você reivindicou com sucesso {{amount}} $eDOP.",
  "vestingBox4.viewTransaction": "Ver Transação",
  "vestingBox4.close": "Fechar",
  "vestingBox4.noTokensAvailable": "Você não tem tokens disponíveis para reivindicar",
  "vestingBox4.claimError": "Erro ao reivindicar tokens:",
  "vestingBox4.unknownError": "Erro desconhecido",

  // Componente VestingBox2
  "vestingBox2.nextRelease": "Próxima Liberação",
  "vestingBox2.noVesting": "Sem vesting",
  "vestingBox2.loading": "Carregando...",
  "vestingBox2.notScheduled": "Não programado",
  "vestingBox2.availableNow": "Disponível agora",
  "vestingBox2.days": "dia(s)",
  "vestingBox2.hours": "hr(s)",
  "vestingBox2.minutes": "min",
  "vestingBox2.amountToRelease": "Quantidade a Liberar",
  "vestingBox2.claimAvailableTokens": "Reivindicar Tokens Disponíveis",
  "stakingBox2.poolPercentage": "% DO POOL",
  "stakingBox2.stakedBalance": "SALDO EM STAKING",
  "stakingBox2.processing": "Processando...",
  "stakingBox2.withdrawTokens": "Retirar Tokens",
  "stakingBox2.success": "Sucesso!",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Aceitar",
  "stakingBox2.tokensWithdrawn": "Tokens retirados com sucesso",
  "stakingBox2.errorWithdrawing": "Não foi possível retirar os tokens",
  "stakingBox2.userRejected": "A transação foi rejeitada pelo usuário",
  "stakingBox2.insufficientFunds": "Fundos insuficientes para realizar a transação",
  "stakingBox2.contractRejection": "A transação foi rejeitada pelo contrato",
  "stakingBox2.infoModal.title": "Porcentagem do Pool",
  "stakingBox2.infoModal.content": "Esta porcentagem representa a proporção dos seus tokens em staking em relação ao total de tokens em staking. Quanto maior sua porcentagem, maior será a proporção de recompensas que você receberá.",
  "stakingBox2.infoModal.understood": "Entendi",

  // Componente VestingBox1
  "vestingBox1.yourVesting": "Seu Vesting",
  "vestingBox1.lockedTokens": "Tokens Bloqueados",
  "vestingBox1.viewDetails": "VER DETALHES",
  "vestingBox1.loading": "Carregando...",
  "vestingBox1.infoModal.title": "Informações sobre o Vesting",
  "vestingBox1.infoModal.content": "O vesting é um período durante o qual seus tokens são liberados gradualmente. \"Tokens Bloqueados\" representam a quantidade de tokens que ainda não foram liberados e não podem ser reivindicados.",
  "vestingBox1.infoModal.understood": "Entendi",

  // Página de Staking
  "staking.page.title": "Plataforma de Staking eDOP",
  
  // Bolhas de Staking
  "bubbles.staking.platform.title": "Plataforma de Staking eDOP",
  "bubbles.staking.platform.content": "É a função dentro do eDOP onde você pode bloquear seus tokens para apoiar o projeto. Em troca de mantê-los bloqueados lá, a plataforma lhe dá recompensas (mais tokens eDOP).",
  
  "bubbles.staking.benefits.title": "Benefícios do Staking",
  "bubbles.staking.benefits.items": [
    "Ganhe mais eDOP: Você recebe tokens extras como recompensa por bloquear os seus.",
    "Participe nas decisões: Isso lhe dá a oportunidade de votar ou influenciar o futuro do projeto.",
    "Apoie o token: Você ajuda a tornar o valor do token mais estável a longo prazo."
  ],
  
  "bubbles.staking.rewards.title": "Recompensas",
  "bubbles.staking.rewards.content": "Você poderá solicitar suas recompensas acumuladas assim que a função de resgate estiver ativa na plataforma.",

  // Componente StakingBox4
  "stakingBox4.totalRewards": "RECOMPENSAS TOTAIS",
  "stakingBox4.claimRewards": "Solicitar Recompensas",
  "stakingBox4.processing": "Processando...",
  "stakingBox4.claimed": "Solicitado",
  "stakingBox4.success": "Sucesso!",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Aceitar",
  "stakingBox4.noRewards": "Não há recompensas disponíveis para solicitar",
  "stakingBox4.claimedSuccess": "Recompensas solicitadas com sucesso! Você recebeu {{amount}} $eDOP",
  "stakingBox4.errorClaiming": "Não foi possível solicitar as recompensas",
  "stakingBox4.userRejected": "A transação foi rejeitada pelo usuário",
  "stakingBox4.insufficientFunds": "Fundos insuficientes para realizar a transação",
  "stakingBox4.contractRejection": "A transação foi rejeitada pelo contrato",
  
  // Componente StakingBox3
  "stakingBox3.estimatedRewards": "RECOMPENSAS ESTIMADAS",
  "stakingBox3.rewardsDynamic": "• A porcentagem de recompensas é dinâmica",
  "stakingBox3.monthly": "• Mensal = {{rate}}%",
  "stakingBox3.daily": "• Diário = {{rate}}%",

  // Componente StakingBox1
  "stakingBox1.stakedBalance": "SALDO EM STAKING",
  "stakingBox1.stakeable": "SEU STAKEABLE",
  "stakingBox1.stakeNow": "FAZER STAKING AGORA",
  "stakingBox1.success": "Sucesso!",
  "stakingBox1.info": "INFO",
  "stakingBox1.accept": "Aceitar",
  "stakingBox1.connectWallet": "Por favor conecte sua carteira primeiro",
  "stakingBox1.enterValidAmount": "Por favor insira uma quantidade válida",
  "stakingBox1.errorStaking": "Houve um problema ao fazer staking dos seus tokens",
  "stakingBox1.userRejected": "A transação foi rejeitada pelo usuário",
  "stakingBox1.insufficientFunds": "Fundos insuficientes para realizar a transação",
  "stakingBox1.contractRejection": "A transação foi rejeitada pelo contrato",
  "stakingBox1.stakeTokens": "Fazer Staking de Tokens",
  "stakingBox1.processingTransaction": "Processando Transação",
  "stakingBox1.waitForStaking": "Por favor aguarde enquanto seu staking é concluído...",
  "stakingBox1.transactionSuccess": "Transação Bem-Sucedida!",
  "stakingBox1.successStaked": "Você fez staking com sucesso de {{amount}} $eDOP",
  "stakingBox1.exit": "Sair",
  "stakingBox1.available": "Disponível: {{amount}}",
  "stakingBox1.confirm": "Aceitar",
  "stakingBox1.cancel": "Cancelar",
  
  // Componente StakingSupply
  "stakingSupply.title": "Suprimento Total de Staking",
  "stakingSupply.totalSupply": "Suprimento Total (Milhões)",
  
  // Meses abreviados para gráficos
  "months.jan": "Jan",
  "months.feb": "Fev",
  "months.mar": "Mar",
  "months.apr": "Abr",
  "months.may": "Mai",
  "months.jun": "Jun",
  "months.jul": "Jul",
  "months.aug": "Ago",
  "months.sep": "Set",
  "months.oct": "Out",
  "months.nov": "Nov",
  "months.dec": "Dez",
  
  // Componente PresaleBox
  "presaleBox.buyMessage": "COMPRE SEUS TOKENS $eDOP AGORA",
  "presaleBox.days": "Dias",
  "presaleBox.hours": "Horas",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Seg",
  "presaleBox.presalePending": "Pré-venda em breve",
  "presaleBox.presaleCompleted": "Pré-venda concluída",
  "presaleBox.stage": "Etapa {{current}} de {{total}}",
  "presaleBox.fundsRaised": "USDT arrecadados: ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "Seus Tokens eDOP Comprados: {{amount}}",
  "presaleBox.tokensStaked": "Seus tokens $eDOP em staking = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Pagar com {{currency}}",
  "presaleBox.receive": "Receber $eDOP",
  "presaleBox.maximum": "Máximo",
  "presaleBox.insufficientFunds": "Você não tem {{currency}} suficiente para pagar esta transação.",
  "presaleBox.buyWithBnb": "Comprar com {{symbol}}",
  "presaleBox.buyWithUsdt": "Comprar com {{symbol}}",
  "presaleBox.buyWithCard": "Comprar com Cartão",
  "presaleBox.goToDex": "Ir para DEX",
  "presaleBox.balance": "Saldo em {{currency}}:",
  "presaleBox.connectWallet": "Conectar carteira",
  "presaleBox.reloadBnb": "Sem BNB suficiente? Recarregue aqui",
  "presaleBox.developedBy": "Desenvolvido por",
  
  // Modal informativo para PresaleBox
  "presaleBox.infoModal.title": "Atenção!",
  "presaleBox.infoModal.tokensPurchased": "O total de tokens que você comprou são todos os tokens adquiridos com a carteira conectada. Isso inclui todos os tokens em staking e não em staking.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "$eDOP não reivindicados comprados com ETH ou USDT ERC-20 podem ser usados em staking agora. Observe que todos os tokens usados em staking antecipado podem ser retirados 7 dias após a ativação da reivindicação de tokens, que ocorrerá após a conclusão da pré-venda.",
  
  // Alertas para PresaleBox
  "presaleBox.alert.connectWallet": "Por favor conecte sua carteira primeiro",
  "presaleBox.alert.enterValidAmount": "Por favor insira uma quantidade válida",
  "presaleBox.alert.presaleNotStarted": "A pré-venda começa em 01 de junho de 2025. Por favor aguarde o início da pré-venda.",
  "presaleBox.alert.confirmInWallet": "Por favor confirme a transação na sua carteira...",
  "presaleBox.alert.purchaseSuccess": "Compra bem-sucedida! Você comprou {{amount}} tokens eDOP",
  "presaleBox.alert.paymentMethodNotSupported": "Método de pagamento não suportado",
  
  // Erros simplificados para PresaleBox
  "presaleBox.error.insufficientTokens": "Não há tokens suficientes disponíveis no momento. Por favor tente novamente mais tarde.",
  "presaleBox.error.userDenied": "Transação rejeitada. Você deve confirmar a transação em sua carteira para continuar.",
  "presaleBox.error.gas": "Erro de gas na transação. Certifique-se de ter BNB suficiente para cobrir as taxas de gas.",
  "presaleBox.error.nonce": "Erro na sequência da transação. Tente atualizar a página e tentar novamente.",
  "presaleBox.error.contractFailure": "A transação falhou. O contrato pode estar pausado ou sem tokens.",
  "presaleBox.error.generic": "Erro na transação. Por favor tente novamente mais tarde.",
  
  // Rede necessária para PresaleBox
  "presaleBox.network.bnbMainnet": "BNB Smart Chain",
  "presaleBox.network.bnbTestnet": "BSC Testnet",
  "presaleBox.network.bnbBoth": "BNB Smart Chain ou BSC Testnet",
  "presaleBox.network.usdtBep20": "BNB Smart Chain (para USDT BEP-20)",
  "presaleBox.network.usdtErc20": "Ethereum (para USDT ERC-20)",
  "presaleBox.network.usdtTestnet": "BSC Testnet (para USDT Testnet)",
  "presaleBox.network.usdtOptions": "Ethereum (para USDT ERC-20) ou BNB Smart Chain (para USDT BEP-20)",
  "presaleBox.network.usdtOptionsTestnet": "Ethereum (para USDT ERC-20) ou BNB Smart Chain/Testnet (para USDT BEP-20)",
  "presaleBox.network.compatible": "rede compatível",
  "presaleBox.network.changeNetwork": "Para pagar com {{method}}, você precisa mudar para a rede {{network}}",
  
  // Mensagens de erro para contratos
  "contracts.error.invalidConfig": "Contrato {{contractName}} não configurado corretamente",
  "contracts.error.initialization": "Erro ao inicializar o contrato {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "O contrato não está inicializado",
  "contracts.error.walletNotConnected": "Carteira não conectada. Por favor, conecte sua carteira para continuar",
  "contracts.error.transaction": "Erro na transação: {{error}}",
  "errors.contractInitialization": "Erro ao inicializar contratos",
  
  // Mensagens de erro para carteiras
  "wallet.error.noMetamask": "MetaMask não está instalado",
  "wallet.error.noAccount": "Não foi possível obter a conta",
  "wallet.error.networkNotSupported": "Rede não suportada",
  "wallet.error.connection": "Erro ao conectar carteira",
  "wallet.error.networkSwitch": "Erro ao mudar de rede",
  
  // Mensagens de erro para a pré-venda
  "presale.error.connectWalletFirst": "Por favor conecte sua carteira primeiro",
  "presale.error.contractNotReady": "O contrato de pré-venda não está pronto",
  "presale.error.noSigner": "Não foi possível obter o assinante. Por favor reconecte sua carteira.",
  "presale.error.priceChanged": "Erro de preço: O preço mudou. Por favor atualize a página.",
  "presale.error.userRejected": "Transação rejeitada pelo usuário",
  "presale.error.insufficientFunds": "Fundos insuficientes para completar a transação",
  "presale.error.purchaseError": "Erro na compra: {{error}}",
  "presale.error.unknown": "Desconhecido",
  "presale.error.usdtApprovalError": "Erro na aprovação de USDT",
  "presale.error.cannotClaimTokens": "Não é possível reivindicar tokens neste momento",
  
  // Mensagens de console - apenas para desenvolvedores, não mostradas aos usuários
  "console.contracts.initialized": "Contratos de pré-venda inicializados com sucesso",
  "console.contracts.initError": "Erro ao inicializar contratos:",
  "console.tokens.availableError": "Erro ao carregar tokens disponíveis:",
  "console.exchangeRates.error": "Erro ao buscar taxas de câmbio:",
  "console.price.error": "Erro ao obter preço do contrato:",
  "console.price.fromContract": "Preço obtido do contrato:",
  "console.price.contractError": "Erro ao obter preço do contrato:",
  "console.price.usingFallback": "Usando preço alternativo:",
  "console.bnb.buying": "Comprando com BNB: {{amount}} BNB para obter {{tokensToReceive}} tokens",
  "console.price.perToken": "Preço por token: {{price}} USDT",
  "console.signer.available": "Assinante disponível: {{available}}",
  "console.account.current": "Conta atual: {{account}}",
  "console.bnb.success": "Compra com BNB bem-sucedida:",
  "console.bnb.error": "Erro ao comprar com BNB:",
  "console.usdt.approving": "Aprovando gasto de USDT...",
  "console.price.fromContractUsdt": "Preço obtido do contrato (USDT):",
  "console.price.contractErrorUsdt": "Erro ao obter preço do contrato (USDT):",
  "console.price.usingFallbackUsdt": "Usando preço alternativo (USDT):",
  "console.usdt.buying": "Comprando com USDT: {{amount}} USDT com preço {{price}} por token",
  "console.tokens.expected": "Tokens esperados: {{tokens}}",
  "console.usdt.success": "Compra com USDT bem-sucedida:",
  "console.usdt.error": "Erro ao comprar com USDT:",
  "console.tokens.claimSuccess": "Tokens reivindicados com sucesso:",
  "console.tokens.claimError": "Erro ao reivindicar tokens:",
  "console.purchases.error": "Erro ao obter dados de compras:",

  // Mensagens do Ticker
  "ticker.message1": "1️⃣ Participe da pré-venda do eDOP! 🚀 Aproveite os preços exclusivos antes do lançamento. 🔥",
  "ticker.message2": "2️⃣ eDOP revoluciona o mercado! 💎 Junte-se ao ecossistema e garanta seu lugar na nova era digital. ⚡",
  "ticker.message3": "3️⃣ Últimos dias da pré-venda do eDOP! ⏳ Não fique de fora, garanta seus tokens antes que seja tarde demais. 🎯",

  // Meta Tags
  "meta.description": "eDOP Token - A moeda do ecossistema financeiro dominicano"
};

export default pt;